<template>
  <v-dialog
    v-model="open"
    width="600px"
    :fullscreen="isMobileBreakpoint"
    :persistent="isMobileBreakpoint"
  >
    <v-card>
      <v-toolbar elevation="0" color="background">
        <v-toolbar-title class="pl-3 dupVideoModalTitle">
          {{ $t('message.pages.duplicateVideoModal.title') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="open = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-row class="px-6 mb-2 dupVideoModalDescription">
        <v-col>
          <v-col class="pa-0">
            <span>{{ $t('message.pages.duplicateVideoModal.message') }}</span>
            <div v-if="errors.duplicatingVideo" class="mt-2 text--error">
              <span>{{
                $t('message.pages.duplicateVideoModal.errorMessage')
              }}</span>
              <template v-if="errors.status || errors.message">
                <br />
                <span v-if="errors.message">{{ errors.message }}.</span>
                <span v-else-if="errors.status"
                  >Status: {{ errors.status }}.</span
                >
              </template>
            </div>
          </v-col>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <!-- Botões de ação -->
      <v-card-actions
        :class="isMobileBreakpoint ? 'mobile-actions' : ''"
        class="px-8 py-6 pb-6"
      >
        <v-spacer></v-spacer>
        <base-btn type="tertiary" class="mr-4 px-4" @click="open = false">
          {{ $t('message.cancel') }}
        </base-btn>
        <base-btn
          type="primary"
          class="px-10"
          :disabled="loadings.isDuplicating"
          :loading="loadings.isDuplicating"
          @click="handleDuplicate"
        >
          {{ $t('message.duplicate') }}
        </base-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import videosApi from '@/services/videosApi.js'
import playerApi from '@/services/playerApi'
import i18n from '@/translations/lang'
import { THUMB_URL } from '@/config/envs.js'
import { mapState } from 'vuex'

export default {
  name: 'DuplicateVideoModal',
  data: () => ({
    loadings: {
      isDuplicating: false,
    },
    errors: {
      duplicatingVideo: false,
      status: false,
      message: false,
    },
  }),
  props: {
    videoId: {
      type: String,
      required: true,
    },
    openModal: {
      type: Boolean,
      default: null,
    },
    goToDuplicatedVideo: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    open(val) {
      if (val === false) this.$root.$emit('VideoDuplicateModalHasClosed')
    },
  },
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
    }),
    open: {
      get() {
        return this.openModal
      },
      set(newValue) {
        if (!newValue) {
          this.$emit('close')
        }
      },
    },
  },
  mounted() {
    if (!window.db) {
      this.$root.$emit('initDexie')
    }
  },
  methods: {
    handleChat() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
    },
    getThumbsLink(thumb, pullzone) {
      if (thumb.includes('/')) {
        thumb = thumb.split('/').slice(-1)
      }
      return `${THUMB_URL}/${pullzone}/${thumb}`
    },
    generateUuid() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      )
    },
    async fetchBlobFile(url, name) {
      try {
        const response = await fetch(url)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const blob = await response.blob()
        return new File([blob], name, { type: blob.type })
      } catch (error) {
        console.error('Error fetching the file:', error)
        return null
      }
    },
    generateThumbCta(thumbnail, type, ctaInfo, thumbName) {
      let codeThumbnail
      let ctaScript
      if (type === 'pauseThumbnail') {
        if (ctaInfo.metadata.thumb.hasButton) {
          ctaScript = ctaInfo.script
          const base64Index = ctaScript.indexOf(
            // eslint-disable-next-line quotes
            `background-image: url('data:image`
          )
          if (base64Index >= 0) {
            const base64Content = ctaScript
              // eslint-disable-next-line quotes
              .split(`background-image: url('`)[1]
              // eslint-disable-next-line quotes
              .split(`')`)[0]
            ctaScript = ctaScript.replace(base64Content, thumbnail)
          }
        } else {
          ctaScript =
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            'ipt>'
        }
      }

      if (type === 'pauseThumbnail') {
        codeThumbnail = thumbnail
          ? {
              id: this.generateUuid(),
              script: ctaScript,
              type: 'pause',
              metadata: {
                thumb: {
                  title: ctaInfo.metadata.thumb.title,
                  startTime: ctaInfo.startTime,
                  endTime: ctaInfo.endTime,
                  hasButton: ctaInfo.metadata.thumb.hasButton || false,
                  type: 'pause',
                  lastAllVideo: ctaInfo.metadata.thumb.lastAllVideo || false,
                  lastTillEnd: ctaInfo.metadata.thumb.lastTillEnd || false,
                },
                fileUrl: thumbnail,
                thumbId: thumbName,
              },
              startTime: ctaInfo.startTime,
              endTime: ctaInfo.endTime,
            }
          : false
        if (ctaInfo?.metadata.button && thumbnail) {
          codeThumbnail.metadata.button = ctaInfo.metadata.button
        }
      }

      if (type === 'endThumbnail') {
        codeThumbnail = {
          id: this.generateUuid(),
          script:
            `<img src='${thumbnail}' style='object-fit:cover; width:100%; height:100%;'><script>document.querySelector('img').onclick=function() { window.parent.postMessage({type: 'cta_play',}, '*') }</scr` +
            'ipt>',
          type: 'end',
          metadata: {
            fileUrl: thumbnail,
          },
        }
      }
      return codeThumbnail
    },
    async handleUpdateConfigThumbnail(
      thumbName,
      pullzone,
      videoId,
      type,
      ctaInfo = null
    ) {
      const endThumbnailLink = this.getThumbsLink(thumbName, pullzone)

      try {
        const cta = await this.generateThumbCta(
          endThumbnailLink,
          type,
          ctaInfo,
          thumbName
        )
        await playerApi.addCta(videoId, cta)
      } catch (e) {
        console.error(e)
      }
    },
    async handleDuplicate() {
      this.loadings.isDuplicating = true
      try {
        const { data } = await videosApi.cloneVideo(this.videoId)
        const [
          { data: duplicatedVideo },
          { data: originalVideo }
        ] = await Promise.all([
          videosApi.getAVideo(data.id),
          videosApi.getAVideo(this.videoId)
        ])

        const thumbnailUrl = originalVideo.thumbnail

        const thumbFile = await this.fetchBlobFile(
          thumbnailUrl,
          'thumbnail.png'
        )

        const formData = new FormData()
        formData.append('file', thumbFile)

        await videosApi.addThumbnailToVideo(data.id, formData)

        if (originalVideo.config.ctas) {
          let pauseThumbFileCount = 1
          let endThumbFileCount = 1

          for (const cta of originalVideo.config.ctas) {
            if (cta.type === 'pause') {
              const pauseThumbFile = await this.fetchBlobFile(
                cta.metadata.fileUrl,
                `pauseThumbnail_${pauseThumbFileCount}.png`
              )

              const formData = new FormData()
              formData.append('file', pauseThumbFile)

              const ret = await videosApi.addThumbnailToPauseVideo(
                data.id,
                formData
              )

              const thumbName = ret?.data?.response?.pauseThumbnail[0]
              await this.handleUpdateConfigThumbnail(
                thumbName,
                originalVideo.pullzone_name,
                data.id,
                'pauseThumbnail',
                cta
              )
              pauseThumbFileCount += 1
            }

            if (cta.type === 'end') {
              const endThumbFile = await this.fetchBlobFile(
                cta.metadata.fileUrl,
                `endThumbnail_${endThumbFileCount}.png`
              )
              const formData = new FormData()
              formData.append('file', endThumbFile)

              const ret = await videosApi.addThumbnailToEndVideo(
                data.id,
                formData
              )
              const thumbName = ret.data.response.endThumbnail
              await this.handleUpdateConfigThumbnail(
                thumbName,
                originalVideo.pullzone_name,
                data.id,
                'endThumbnail',
                null
              )
              endThumbFileCount += 1
            }
          }
        }

        this.errors.duplicatingVideo =
          this.errors.status =
          this.errors.message =
            false
        this.$root.$emit('addVideoVideosPage', duplicatedVideo)
        if (this.goToDuplicatedVideo) {
          this.$root.$emit('goToDuplicatedVideo', data.id)
        }
        this.open = false
      } catch (e) {
        if (e.response?.status) {
          this.errors.status = e.response.status
        }
        if (e.response?.data?.errMsg) {
          const errorMessageTranslation = this.getErrorMessageTranslation(
            e.response.data?.errMsg,
            this.videoId
          )
          if (errorMessageTranslation) {
            this.errors.message = errorMessageTranslation
          }
        }
        this.errors.duplicatingVideo = true
        console.error(e)
      }
      this.loadings.isDuplicating = false
    },
    getErrorMessageTranslation(string, videoId = false) {
      if (string === 'Error to save clone in DB') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.saveInDB'
        )
      }
      if (string === 'Error to save clone in SQS') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.saveInSQS'
        )
      }
      if (string === 'Video is not in CONVERTED status') {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.notConvertedStatus'
        )
      }
      if (
        string.includes('Video with video_id:') &&
        string.includes('was not found') &&
        videoId
      ) {
        return i18n.t(
          'message.pages.duplicateVideoModal.responseErrors.videoNotFound',
          { video_id: videoId }
        )
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.dupVideoModalTitle {
  color: varFigma(neutral-20-dark);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%; /* 21.6px */
}

.dupVideoModalDescription {
  color: varFigma(neutral-40-light);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--v-background-base);
  z-index: 10;
  padding: 16px;
}
</style>
